import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSortModule } from '@angular/material/sort';
import { bootstrapApplication } from '@angular/platform-browser';
import { LibLoginConfig, LibLoginInterceptor, LibLoginModule } from '@badgertechnologies/liblogin.js';
import {
  AuthorizationService,
  CommandService,
  CustomIconService,
  DeviceService,
  DialogService,
  ErrorService,
  LifecycleService,
  ManufacturingFacilityService,
  MessageService,
  MultiUserRoomService,
  NavZoneService,
  OrganizationSelectionService,
  OrganizationService,
  PlayService,
  RobotEscalationService,
  RobotEscalationWhitelistEventService,
  RobotModelService,
  RobotService,
  RoleGuard,
  ScanConfigService,
  ScanConfigTypeService,
  ScannableToScanConfigService,
  ScheduleService,
  SoftwareImageService,
  StoreService,
  ThemeService,
  TimezoneService,
  TitleService,
  UserService,
  VerificationService,
  ZoneService
} from '@ng-cloud/badger-core';
import { provideTranslateService } from '@ngx-translate/core';
import { ActionCableService } from 'angular2-actioncable';
import { HotkeyModule } from 'angular2-hotkeys';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';

import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      AppRoutingModule,
      ToastrModule.forRoot({
        timeOut: 3000,
        positionClass: 'toast-top-right',
        preventDuplicates: true
      }),
      HotkeyModule.forRoot({ cheatSheetCloseEsc: false }),
      {
        ngModule: LibLoginModule,
        providers: [
          {
            provide: LibLoginConfig,
            useValue: {
              fleet: environment.apiBase,
              ...environment.keycloak
            }
          },
          {
            provide: HTTP_INTERCEPTORS,
            useClass: LibLoginInterceptor,
            multi: true
          }
        ]
      },
      MatButtonModule,
      MatIconModule,
      MatInputModule,
      MatSortModule,
      MatDatepickerModule,
      MatMomentDateModule
    ),
    RoleGuard,
    ActionCableService,
    MessageService,
    MultiUserRoomService,
    CustomIconService,
    DialogService,
    ErrorService,
    RobotService,
    RobotEscalationService,
    RobotEscalationWhitelistEventService,
    LifecycleService,
    StoreService,
    UserService,
    CommandService,
    PlayService,
    OrganizationSelectionService,
    OrganizationService,
    ScanConfigTypeService,
    ScanConfigService,
    ScannableToScanConfigService,
    ScheduleService,
    SoftwareImageService,
    ThemeService,
    TitleService,
    DeviceService,
    AuthorizationService,
    VerificationService,
    RobotModelService,
    ManufacturingFacilityService,
    NavZoneService,
    TimezoneService,
    ZoneService,
    { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
    provideHttpClient(withInterceptorsFromDi()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideTranslateService({})
  ]
}).catch((error) => console.error(error));
